export default "__VITE_ASSET__9b6d5a30__"